module.exports = __webpack_public_path__ + "img/横屏手机.bbf3a8c7.png";